import styled from '@emotion/styled';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 550px;
  max-width: 100%;
  max-height: 80vh;
`;

export const ModalField = styled.div`
  margin-bottom: 12px;
  input[type='text'] {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  input[type='file'] {
    width: 100%;
  }

  textarea {
    width: 100%;
    padding: 8px;
  }
`;

export const DateTimeRangePickerContainer = styled.div`
  margin-bottom: 12px;
`;

export const CenteredH2 = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

export const ScrollableContent = styled.div`
  overflow-y: auto;
  max-height: 60vh;
  padding-right: 20px;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 20px;
`;

export const ColorOption = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  margin-right: 8px;
  display: inline-block;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;

  input {
    margin-right: 8px;
  }
`;
